<div class="background-image-container mt-ncs">
  <div class="container">
    <div class="home-news-content py-4 px-2 py-sm-5 px-sm-0 mt-0 mb-4">
      @if (homeNewsMetadataValue$ | async; as homeNewsMetadataValue) {
        <div class="container">
          <div class="jumbotron jumbotron-fluid">
            <ds-markdown-viewer [value]="homeNewsMetadataValue"></ds-markdown-viewer>
          </div>
        </div>
      }
      @else {
        <div class="d-flex flex-wrap">
          <div>
            <h1 class="display-2">ENSIA Institutional Repository</h1>
            <p class="lead">The Open Archive of the National School of Artificial Intelligence (ENSIA)</p>
          </div>
        </div>
      }
    </div>
  </div>
  <picture class="background-image">
    <source type="image/webp" srcset="assets/dspace/images/banner.webp 2000w, assets/dspace/images/banner-half.webp 1200w, assets/dspace/images/banner-tall.webp 768w">
    <source type="image/jpg" srcset="assets/dspace/images/banner.jpg 2000w, assets/dspace/images/banner-half.jpg 1200w, assets/dspace/images/banner-tall.jpg 768w">
    <img alt="" [src]="'assets/dspace/images/banner.jpg'"/><!-- without the []="''" Firefox downloads both the fallback and the resolved image -->
  </picture>
  <small class="credits">Photo by <a href="https://www.pexels.com/@inspiredimages">&#64;inspiredimages</a></small>
</div>
